import { useEffect, useState } from "react";

/**
 * The current time, refreshed every `intervalMs` while `enabled`. Timers
 * display from this but never count on it: the answer always comes from the
 * clock and a start time (D56), so a missed tick is harmless.
 */
export function useNow(enabled = true, intervalMs = 1000): Date {
	const [now, setNow] = useState(() => new Date());
	useEffect(() => {
		if (!enabled) return;
		const tick = () => setNow(new Date());
		// Refresh right away (not synchronously in the effect), then every interval.
		const first = setTimeout(tick, 0);
		const id = setInterval(tick, intervalMs);
		// A sleeping phone skips ticks; catch up the moment the tab is visible again.
		const onVisible = () => {
			if (document.visibilityState === "visible") tick();
		};
		document.addEventListener("visibilitychange", onVisible);
		return () => {
			clearTimeout(first);
			clearInterval(id);
			document.removeEventListener("visibilitychange", onVisible);
		};
	}, [enabled, intervalMs]);
	return now;
}
